import i18n from '@/i18n/i18n'
import { SHIPPING_INCOMING_ORDERS_ROUTE } from '@/router/routes/shipping.routes'

export const PREVIEW_ROUTE = 'preview'
export const PREVIEW_TRACKING_PAGE_ROUTE = 'preview.tracking-page'

export default {
  name: PREVIEW_ROUTE,
  path: '/preview',
  redirect: { name: SHIPPING_INCOMING_ORDERS_ROUTE },
  component: () => import('@/app/settings/ParentRoutePlaceholder.vue'),
  children: [
    {
      name: PREVIEW_TRACKING_PAGE_ROUTE,
      path: '/preview/track-and-trace',
      component: () => import('@/app/preview/views/TrackingPage.vue'),
      meta: {
        pageTitle: () => i18n.t('Tracking page preview'),
        permissions: ['configure_tracking'],
      },
    },
  ],
}
